import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';

const resetData = (state) => {
  state.menuBannerRecommendationList = [];
};

const recommendationListSuccess = (state, menuBannerRecommendationList) => {
  state.menuBannerRecommendationList = menuBannerRecommendationList;
};

const createBannerRecommendationSuccess = (state, payload) => {
  state.menuBannerRecommendationList.push(payload);
};

const editBannerRecommendationListSuccess = (state, payload) => {
  const foundIndex = state.menuBannerRecommendationList.findIndex((recommendation) => recommendation.guid === payload.guid);
  state.menuBannerRecommendationList[foundIndex] = payload;
};

const removeRecommendationListSuccess = (state, payload) => {
  state.menuBannerRecommendationList = state.menuBannerRecommendationList.filter(((recommendation) => recommendation.guid !== payload.guid));
};

export const mutations = {
  [MutationTypes.BANNER_RECOMMENDATION_LIST_SUCCESS]: recommendationListSuccess,
  [MutationTypes.CREATE_BANNER_RECOMMENDATION_SUCCESS]: createBannerRecommendationSuccess,
  [MutationTypes.EDIT_BANNER_RECOMMENDATION_SUCCESS]: editBannerRecommendationListSuccess,
  [MutationTypes.DELETE_BANNER_RECOMMENDATION_SUCCESS]: removeRecommendationListSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetData,
};
